import { BaseComponent } from './../base/base.component';
import { Component, OnInit } from '@angular/core';

declare var window:any;

@Component({
  selector: 'app-header',
  template: require('./header.component.html')
})
export class HeaderComponent extends BaseComponent implements OnInit {

  ngOnInit() {
    this.lsApp.isUserLoggedIn();
    setTimeout(()=>{
      try {
        window.mLayout.init();
      }
      catch(ex) {
        console.log(ex);
      }
    },100);
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/header/header.component.ts